import { ApiKeySecretResponse, CreateApiKeyRequest } from './types';
import { axiosMeedioClient } from '../client';

export const createApiKey = async (
  workspaceId: string,
  payload: CreateApiKeyRequest
): Promise<ApiKeySecretResponse> => {
  const { data } = await axiosMeedioClient.post<ApiKeySecretResponse>(
    `/v1/workspaces/${workspaceId}/api-keys`,
    payload
  );
  return data;
};
